import { getStorageItem } from '../../../utils/storage'

import { EmailCopyToEntityFormModal } from './EmailCopyToEntityFormModal'
import { EMAIL_COPY_TO_ENTITY_MODAL_IS_PRIVATE_CONFIRMATION_AGAIN_DISABLED } from './EmailCopyToEntityModal.constants'
import { EmailCopyToEntityPrivateConfirmationModal } from './EmailCopyToEntityPrivateConfirmationModal'

function EmailCopyToEntityModal({
  isPrivate,
  onClose,
  onSetModal,
  ...restProps
}) {
  const isPrivateConfirmationShowDisabled = getStorageItem(
    EMAIL_COPY_TO_ENTITY_MODAL_IS_PRIVATE_CONFIRMATION_AGAIN_DISABLED
  )

  const formModal = (
    <EmailCopyToEntityFormModal {...restProps} onClose={onClose} />
  )

  function handleOpenCopyToModal() {
    onSetModal(formModal)
  }

  if (isPrivate && !isPrivateConfirmationShowDisabled) {
    return (
      <EmailCopyToEntityPrivateConfirmationModal
        onCancel={onClose}
        onSubmit={handleOpenCopyToModal}
      />
    )
  }

  return formModal
}

export default EmailCopyToEntityModal
